export { default } from './PageHeading.vue'
